import { Controller } from '@hotwired/stimulus'

// F8 toast: a success message removes itself after a while; an error (sticky) stays until closed. Pointer or focus
// inside (e.g. on „Vrátit“) holds it open, the time starts again when they leave.
export default class ToastController extends Controller<HTMLElement> {
  static override values = { sticky: Boolean, delay: { type: Number, default: 8000 } }
  declare readonly stickyValue: boolean
  declare readonly delayValue: number
  private timer: number | undefined

  override connect(): void {
    if (this.stickyValue) return

    this.start()
    for (const name of ['mouseenter', 'focusin']) this.element.addEventListener(name, this.pause)
    for (const name of ['mouseleave', 'focusout']) this.element.addEventListener(name, this.start)
  }

  override disconnect(): void {
    window.clearTimeout(this.timer)
  }

  close(): void {
    this.element.remove()
  }

  private readonly start = (): void => {
    window.clearTimeout(this.timer)
    this.timer = window.setTimeout(() => this.close(), this.delayValue)
  }

  private readonly pause = (): void => {
    window.clearTimeout(this.timer)
  }
}
